export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/seller_page_perseus/play_icon.367b98d.svg";